import { render, staticRenderFns } from "./BusquedaPersona.vue?vue&type=template&id=b6b6ff96"
import script from "./BusquedaPersona.vue?vue&type=script&lang=js"
export * from "./BusquedaPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports